import { render, staticRenderFns } from "./TmSelectors.vue?vue&type=template&id=2ec16cce&scoped=true"
import script from "./TmSelectors.vue?vue&type=script&lang=js"
export * from "./TmSelectors.vue?vue&type=script&lang=js"
import style0 from "./TmSelectors.vue?vue&type=style&index=0&id=2ec16cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec16cce",
  null
  
)

export default component.exports